import { linkifyNbfc } from "./NbfcLink";
import React from "react";
import Footer from "./Footer";
import Navbar from "./Navbar";

const TermsConditions: React.FC = () => {
  const termsSections = [
    {
      title: "1. Introduction",
      content:
        `${import.meta.env.VITE_COMPANY_NAME} provides personal loans to salaried individuals under the regulatory oversight of ${import.meta.env.VITE_COMPANY_NBFC} Our goal is to offer instant, easy, and transparent financial solutions.`,
    },
    {
      title: "2. Eligibility Criteria",
      content:
        "To apply for a personal loan, you must meet the following requirements:",
      list: [
        "Be at least 21 years old and not older than 60 at the time of application.",
        "Be a salaried individual with stable income from a recognized organization.",
        `Meet the minimum monthly income criteria defined by ${import.meta.env.VITE_COMPANY_NBFC}`,
        "Be a resident of India with a satisfactory credit score and financial history.",
      ],
    },
    {
      title: "3. Loan Application Process",
      content:
        `The process includes registration, application form, document submission, and credit assessment. Approval is solely at the discretion of ${import.meta.env.VITE_COMPANY_NBFC}`,
    },
    {
      title: "4. Loan Terms",
      content:
        "Loan amount, interest rate, and repayment schedule are determined based on applicant profile. Interest rate remains fixed during the tenure.",
    },
    {
      title: "5. Fees and Charges",
      content:
        "Applicable fees may include processing fee, late payment charges, Early repayment may attract prepayment penalties, etc., as mentioned in the loan agreement.",
    },
    {
      title: "6. Loan Disbursement",
      content:
        `Once approved and formalities completed, the loan amount will be credited to your bank account. Disbursement timelines may vary, but ${import.meta.env.VITE_COMPANY_NAME} strives for quick processing.`,
    },
    {
      title: "7. Loan Repayment",
      content:
        "Repayments must follow the schedule outlined in the loan agreement. Payments may be auto-debited via NACH or through digital methods such as UPI. Early repayment may attract foreclosure charges.",
    },
    {
      title: "8. Default and Consequences",
      content:
        "Failure to repay on time may lead to late fees, negative reporting to credit bureaus, and possible legal action.",
    },
    {
      title: "9. Cancellation of Loan",
      content:
        "Applications may be cancelled before disbursement. Once disbursed, cancellation is not possible. Prepayment is allowed as per agreement terms.",
    },
    {
      title: "10. Data Privacy and Security",
      content:
        "All information is handled securely in compliance with data protection laws and used only for loan processing and communication.",
    },
    {
      title: "11. User Responsibilities",
      content:
        "You must provide accurate details during registration and application. Misrepresentation may lead to denial of service or legal action.",
    },
    {
      title: "12. Amendments to Terms",
      content:
        "We may update these terms anytime. Updates will be posted on our website, and it is your responsibility to stay informed.",
    },
    {
      title: "13. Dispute Resolution",
      content:
        "Disputes will first be attempted to resolve amicably. If unresolved, they fall under the jurisdiction of courts in Delhi, India.",
    },
    {
      title: "14. Limitation of Liability",
      content:
        `${import.meta.env.VITE_COMPANY_NBFC} is not liable for any loss, damage, or inconvenience arising from the use of this website or services, except as expressly mentioned in the loan agreement.`,
    },
    {
      title: "15. Governing Law",
      content:
        "These Terms and Conditions are governed by and construed in accordance with the laws of India.",
    },
  ];

  return (
    <div className="min-w-screen bg-[var(--background-gradient-middle)]">
      <div className="max-w-[1440px] mx-auto flex flex-col gap-12 px-4 sm:px-6 lg:px-12 py-16">
        <Navbar />

        {/* Hero Section */}
        <div className="text-center mt-12 relative z-10 w-full mb-2">
          <h1 className="text-4xl md:text-7xl font-[900] leading-none tracking-tighter mb-4 bg-gradient-to-r from-[var(--primary)] to-[var(--secondary-accent)] text-transparent bg-clip-text">
            Terms & Conditions
          </h1>

          <p className="text-[var(--text-gray)] font-bold text-lg md:text-xl max-w-3xl mx-auto leading-relaxed">
            Welcome to{" "}
            <span className="font-semibold text-[var(--primary)] text-xl">
              {import.meta.env.VITE_COMPANY_NAME}
            </span>
            . By accessing and using our website or applying for any of our loan
            products, you agree to comply with these terms.
          </p>
        </div>

        {/* Policy Content */}
        <div className="max-w-4xl w-full mx-auto">
          <div className="bg-white/40 backdrop-blur-3xl rounded-[32px] md:rounded-[40px] border-2 border-white/50 shadow-[20px_20px_40px_rgba(0,0,0,0.04)] p-8 md:p-12 space-y-10">
            {termsSections.map((section, idx) => (
              <div key={idx} className="space-y-4">
                <h2 className="text-2xl font-[900] text-[var(--text-primary)] tracking-tight mb-2 border-b-2 border-[var(--primary)]/20 pb-2">
                  {linkifyNbfc(section.title)}
                </h2>
                {section.content && (
                  <p className="text-[var(--text-gray)] text-base whitespace-pre-line leading-relaxed font-medium">
                    {linkifyNbfc(section.content)}
                  </p>
                )}
                {section.list && (
                  <ul className="list-disc list-outside ml-6 space-y-2 text-[var(--text-gray)] text-base font-medium">
                    {section.list.map((li, i) => (
                      <li key={i} className="pl-1">{linkifyNbfc(li)}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default TermsConditions;
